import { Component, HostBinding, OnInit } from '@angular/core';
import { PointsService } from 'src/app/services/points.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { GlobalSelectionControlService } from '../services/global-selection-control.service';
import { EventListenersOnMap } from 'src/app/utils/eventListenersOnMap';
import { IdentifyToolService } from 'src/app/services/identify-tool.service';
import { SelectByFirComponent } from 'src/app/popup/select-by-fir/select-by-fir.component';
import { TerrainHeightService } from '../services/terrain-height.service';
import { DistanceAzimuthService } from '../services/distance-azimuth.service';
import { TerrainAltitudeCutService } from 'src/app/services/terrain-altitude-cut.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-support-ticket-shortcut',
  templateUrl: './support-ticket-shortcut.component.html',
  styleUrls: ['./support-ticket-shortcut.component.scss'],
  standalone: false
})
export class SupportTicketShortcutComponent implements OnInit {

  readonly preReleaseToolEnabled = environment.enablePreReleaseTools;

  @HostBinding('style.display')
  get display(): string {
    return this.preReleaseToolEnabled ? '' : 'none';
  }

  @HostBinding('class.top')
  get isNavigationOnTop(): boolean {
    return this.toolsService.navigationOnTop;
  }

  @HostBinding('class.events-open')
  get hasOpenMapEvent(): boolean {
    return this.displayCloseEventsButton();
  }

  constructor(public globalSelectionService : GlobalSelectionControlService,
      public toolsService : ToolsControlService,
      public pointsService : PointsService,
      private messageModalService: ModalControlService,

  ) {}

  ngOnInit(): void {
  }
  displayCloseEventsButton(): boolean {
      return (
        EventListenersOnMap.hasEvent(IdentifyToolService.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(SelectByFirComponent.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(TerrainHeightService.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(DistanceAzimuthService.EVENT_ON_MAP_LABEL) ||
        EventListenersOnMap.hasEvent(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL)
      );
    }

    getActiveEvent(): string {
      return EventListenersOnMap.getActiveExclusiveEvent();
    }

    openSupportTicketCreation(): void {
        if (!this.preReleaseToolEnabled) {
          return;
        }

        this.messageModalService.openSupportTicketCreationModal();
      }

}
